import { GAME_TITLE } from '../../constants/strings'
import {
  APP_VERSION,
  CLASH_ASSETS,
  CLASH_CREDITS,
  CLASH_LINKS,
} from '../../lib/clashConstants'
import { BaseModal } from './BaseModal'

type Props = {
  isOpen: boolean
  handleClose: () => void
}

export const AboutModal = ({ isOpen, handleClose }: Props) => {
  return (
    <BaseModal title="About" isOpen={isOpen} handleClose={handleClose}>
      <div className="space-y-6">
        <div className="space-y-4 text-center">
          <div className="flex justify-center">
            <img
              src={CLASH_ASSETS.clashLogo}
              alt="CLASH"
              className="h-20 w-auto object-contain"
              onError={(e) => {
                e.currentTarget.style.display = 'none'
              }}
            />
          </div>
          <div>
            <h2 className="text-2xl font-extrabold text-slate-800">
              {GAME_TITLE}
            </h2>
            <p className="mt-1 text-sm font-medium text-slate-500">
              Version {APP_VERSION}
            </p>
          </div>
        </div>

        <p className="text-center text-base leading-relaxed text-slate-600">
          A word puzzle game inspired by the classic Connections format, brought
          to you by the Roslyn OCC.
        </p>

        <div className="flex flex-col items-center gap-4 border-t border-b border-slate-100 py-5">
          <p className="text-xs font-semibold uppercase tracking-widest text-slate-400">
            Presented by
          </p>
          <img
            src={CLASH_ASSETS.occGamesLogo}
            alt="Roslyn OCC Games"
            className="h-30 w-auto object-contain"
            onError={(e) => {
              const target = e.currentTarget
              target.style.display = 'none'
              const fallback = target.nextElementSibling
              if (fallback instanceof HTMLElement) {
                fallback.style.display = 'block'
              }
            }}
          />
          <span
            className="text-lg font-bold text-slate-800"
            style={{ display: 'none' }}
          >
            Roslyn OCC Games
          </span>
        </div>

        <div className="space-y-3">
          <h3 className="text-center text-sm font-bold uppercase tracking-wide text-slate-400">
            Credits
          </h3>
          <div className="text-center">
            <p className="font-semibold text-slate-600">Developed by</p>
            <p className="mt-1 font-bold text-slate-800">
              {CLASH_CREDITS.developers.join(' & ')}
            </p>
          </div>
        </div>

        <div className="flex justify-center gap-6 pt-2">
          <a
            href={CLASH_LINKS.occ}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-slate-500 transition-colors hover:text-[#38B6FF]"
          >
            Visit OCC
          </a>
          <a
            href={CLASH_LINKS.privacy}
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm font-semibold text-slate-500 transition-colors hover:text-[#38B6FF]"
          >
            Privacy Policy
          </a>
        </div>

        <p className="text-center text-xs font-medium text-slate-400">
          © {CLASH_CREDITS.year} {CLASH_CREDITS.organization}. All rights
          reserved.
        </p>
      </div>
    </BaseModal>
  )
}
